let mtd = {}

mtd.logout = async function() {
    let res = await API.account.logout()
    let data = res.data

    if (data.code == "00000") {
        this.cacheTeams()
        let teamCache = localStorage.teamCache

        localStorage.clear()
        localStorage.teamCache = teamCache

        location.href = "/user/login"
    }
}

mtd.cacheTeams = function() {
    let teamCache = {}
    if (localStorage.teamCache && localStorage.teamCache != "undefined") {
        teamCache = JSON.parse(localStorage.teamCache)
    }

    teamCache[localStorage.user_id] = {
        team_id: localStorage.teamId,
        role: localStorage.role,
        teamName: localStorage.teamName
    }

    localStorage.teamCache = JSON.stringify(teamCache)
}

mtd.handleImg = function(src, rule) {
    if (src) {
        if (this.checkEnterprise(localStorage.teamType) || window.useCustomServer) {
            //企业级 & 私有部署
        } else if (src.includes('alipic')) {
            if (!src.includes('x-oss-process')) {
                src += (rule['ali'] || '')
            }
        } else {
            if (!src.includes('imageMogr2')) {
                src += (rule['qiniu'] || '')
            }
        }
        return src
    }
}

mtd.checkEnterprise = function(type) {
    let keys = ["enterprise", "enterprise2"]
    return keys.includes(type)
}

export default mtd
